import { render, staticRenderFns } from "./DocumentsCreateForm.vue?vue&type=template&id=40efbb98&scoped=true"
import script from "./DocumentsCreateForm.vue?vue&type=script&lang=js"
export * from "./DocumentsCreateForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCreateForm.vue?vue&type=style&index=0&id=40efbb98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40efbb98",
  null
  
)

export default component.exports